<template>

  <!-- Public Event Page -->
  <div
    v-if="item"
    class="public-event-page">

    <!-- Header Offset -->
    <div
      v-if="!item.headerOverlay"
      class="page-header-offset"/>

    <!-- Studio Block-->
    <studios-block
      :items="item.studios"/>

    <!-- Vendor Video Block -->
    <page-block
      bg-color="#191919"
      text-color="#FFFFFF"
      v-if="(item.videos || []).length"
      class="public-event-page__video-block"
      :bg-file="{type: 'image/png', link: '/images/bg/bg-studio.png'}">

      <vendor-video-content
        :items="item.videos"/>

    </page-block>

    <!-- Presentations Block -->
    <page-block
      v-if="(item.presentations || []).length">

      <vendor-presentations-content
        :items="item.presentations"/>

    </page-block>

    <!-- Page Blocks -->
    <page-blocks
      :value="item.blocks"/>

  </div>

</template>

<script>

  import {mapState} from 'vuex';
  import MetaMixin from '@src/mixins/meta-mixin';
  import PageBlock from '@src/components/page/page-block';
  import PageBlocks from '@src/components/page/page-blocks';
  import StudiosBlock from '@src/components/block/studios-block';
  import VendorVideoContent from '@src/components/content/vendor-video-content';
  import VendorPresentationsContent from '@src/components/content/vendor-presentations-content';

  export default {
    name: 'public-event-page',
    mixins: [
      MetaMixin,
    ],
    components: {
      PageBlock,
      PageBlocks,
      StudiosBlock,
      VendorVideoContent,
      VendorPresentationsContent,
    },
    async preFetch({store, currentRoute, redirect}) {

      // Set Header.

      store.commit(
        'header/SET_START_COLOR',
        'transparent',
      );

      store.commit(
        'header/SET_START_TEXT_COLOR',
        'white',
      );

      // Fetch Item.

      const item = await store.dispatch(
        'vlEvents/FETCH_ITEM_BY_SLUG',
        {slug: currentRoute.params.slug},
      );

      // Not Found.

      if (!item || !item.published)
        return process.env.SERVER
          ? throw {code: 404}
          : redirect('/error/404');

      // Is Public.

      const isLoggedIn = store.getters[
        'session/isLoggedIn'
      ];

      if (!isLoggedIn && !item.public)
        return redirect('/dialog/login');

      // Set Header.

      if (item.headerOverlay) {

        store.commit(
          'header/SET_START_COLOR',
          item.headerBgColor || 'transparent',
        );

        store.commit(
          'header/SET_START_TEXT_COLOR',
          item.headerTextColor || 'white',
        );

      } else {

        store.commit(
          'header/SET_START_COLOR',
          item.headerBgColor || 'white',
        );

        store.commit(
          'header/SET_START_TEXT_COLOR',
          item.headerTextColor || 'primary',
        );
      }

      // Application.

      store.commit(
        'vlApplications/SET_REFERENCE_ID',
        item.id,
      );

      store.commit(
        'vlApplications/SET_REFERENCE_TYPE',
        'event',
      );
    },
    computed: {
      ...mapState('vlEvents', {
        item: 'item',
      }),
      hasBody() {

        if (
          !this.item ||
          !this.item.body ||
          !this.item.body.ru
        ) return false;

        return this.$u.htmlHasContent(
          this.item.body.ru,
        );
      },
    },
  };

</script>

<style lang="scss">

  .public-event-page {
    background-color: white;

    &__gallery {
      max-height: 80vh;
      min-height: 300px;
    }

    &__video-block:first-child {
      padding-top: $bs-t;
    }
  }

</style>
